{
  "dialog": {
    "createTitle": "New organization",
    "description": "Create a new organization to manage projects and members.",
    "name": "Name",
    "slug": "Identifier (slug)",
    "slugHint": "Lowercase letters, numbers and hyphens only",
    "color": "Color",
    "cancel": "Cancel",
    "submit": "Create",
    "submitting": "Creating..."
  },
  "toast": {
    "created": "Organization created successfully",
    "error": "An error occurred. Please try again.",
    "updated": "Organization updated successfully",
    "updateError": "Failed to update organization. Please try again.",
    "deleteError": "Failed to delete the organization. Please try again."
  },
  "errors": {
    "nameMin": "Name must be at least 2 characters",
    "nameMax": "Name cannot exceed 50 characters",
    "slugMin": "Identifier must be at least 2 characters",
    "slugMax": "Identifier cannot exceed 50 characters",
    "slugInvalid": "Lowercase letters, numbers and hyphens only",
    "colorRequired": "Select a color",
    "descriptionMax": "Description cannot exceed 500 characters",
    "websiteUrlInvalid": "Must be a valid URL (e.g. https://example.com)"
  },
  "apiErrors": {
    "notFound": "Organization not found",
    "slugAlreadyExists": "An organization with this identifier already exists",
    "invalidTier": "The selected plan is not valid",
    "cannotDowngrade": "Cannot downgrade plan: member count exceeds the new plan limit",
    "cannotDelete": "Only the owner can delete the organization",
    "createDefault": "Could not create the organization",
    "updateDefault": "Could not update the organization",
    "deleteDefault": "Could not delete the organization",
    "onboardingConflict": "An organization with that name already exists",
    "onboardingDefault": "Could not complete onboarding. Please try again.",
    "avatarUploadDefault": "Failed to upload organization logo",
    "avatarDeleteDefault": "Failed to remove organization logo"
  }
}
